import { defineCustomElement } from "vue";
import { Register } from "..";
import F360BannerAvisoFilaCe from "./F360BannerAvisoFila.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-banner-aviso-fila")) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const CustomElement = defineCustomElement(F360BannerAvisoFilaCe as any);
      customElements.define("vc-banner-aviso-fila", CustomElement);
    }
  }
};

export default _register;
